import axios from 'axios';

import { KanzhongBackend } from 'constant/KanzhongBackend';
import { ServerError, createApiError } from 'stores/ApiClientError';

// --- 型定義 ---

export type MasterTypeResult = {
  typeCode: string;
  typeLabel: string;
};

// --- API関数 ---

/**
 * 区分取得API
 * @param typeName - 区分名（必須, パスパラメータ）
 */
export const getMasterType = async (typeName: string): Promise<MasterTypeResult[]> => {
  const sessionId = localStorage.getItem('session-id');

  try {
    const response = await axios.get(`${KanzhongBackend.GET_MASTER_TYPE}/${typeName}`, {
      headers: {
        'X-Session-Id': sessionId,
      },
    });

    return response.data.results;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      throw createApiError(status, data?.message || error.message);
    }
    throw new ServerError();
  }
};

// --- typeName固定の便利関数 ---

export const getPartnerType = async (): Promise<MasterTypeResult[]> => {
  return getMasterType('partner_type');
};

export const getClientType = async (): Promise<MasterTypeResult[]> => {
  return getMasterType('client_type');
};

export const getProjectScale = async (): Promise<MasterTypeResult[]> => {
  return getMasterType('project_scale');
};

export const getDistribution = async (): Promise<MasterTypeResult[]> => {
  return getMasterType('distribution');
};

export const getIndustry = async (): Promise<MasterTypeResult[]> => {
  return getMasterType('industry');
};

export const getEmploymentType = async (): Promise<MasterTypeResult[]> => {
  return getMasterType('employment_type');
};

export const getGender = async (): Promise<MasterTypeResult[]> => {
  return getMasterType('gender');
};

export const getContractType = async (): Promise<MasterTypeResult[]> => {
  return getMasterType('contract_type');
};

export const getAssessmentType = async (): Promise<MasterTypeResult[]> => {
  return getMasterType('assessment_type');
};

export const getDisposalReason = async (): Promise<MasterTypeResult[]> => {
  return getMasterType('disposal_reason');
};
